<template>
  <!--<div class="vendor-avatar2 ut-circle-img">{{ strValue }}</div>-->

  <div :class="{ 'vendor-avatar-small': small, 'vendor-avatar' : !small }" class="
  ut-circle-img ut-flex ut-items-center justify-center">
    <span>{{ strValue }}</span>
  </div>

</template>

<script>
export default {
  name: 'FirstInitialName',
  props: {
    str: {
      default: '',
      required: true,
    },
    small: {
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    strValue() {
      return `${this.str.substr(0, 1).toUpperCase()}`;
    },
  },
};
</script>

<style scoped lang="scss">

  .vendor-avatar {
    height: 40px;
    width: 40px;
    font-size: 16px;
    line-height: 40px;
    @apply ut-text-center ut-font-bold ut-ml-0 ut-mr-4 ut-flex-shrink-0 ut-bg-green-400;
    color: #ffffff;

    @screen md {
      height: 64px;
      width: 64px;
      font-size: 32px;
      line-height: 64px;
      @apply ut-mr-6;
    }
  }

  .vendor-avatar-small {
    height: 32px;
    width: 32px;
    font-size: 16px;
    @apply ut-text-center ut-font-bold ut-bg-green-400;
    color:#ffffff;

    @screen md {
      height: 32px;
      width: 32px;
      font-size: 16px;
    }
  }

</style>
